import { selectBookkeepingReportStatus } from '@/selectors/bookkeepingReportsSelectors'
import { useReselector } from '@/utils/sharedHooks'
import { Badge } from '@/ui'

export const BookkeepingStatusLabel = ({ reportId }: { reportId: string }) => {
  const status = useReselector(selectBookkeepingReportStatus, reportId)
  if (!status) {
    return null
  }

  return (
    {
      done: (
        <Badge variant="default" color="green">
          Done
        </Badge>
      ),
      reconciled: (
        <Badge variant="secondary" color="yellow">
          Reconciled
        </Badge>
      ),
      categorized: (
        <Badge variant="secondary" color="orange">
          Bookkeeping Completed
        </Badge>
      ),
      in_progress: (
        <Badge variant="secondary" color="orange">
          In progress
        </Badge>
      ),
      not_started: (
        <Badge variant="secondary" color="red">
          Not Started
        </Badge>
      ),
      plaid_error: (
        <Badge variant="secondary" color="red">
          Plaid Error
        </Badge>
      ),
      missing_info: (
        <Badge variant="secondary" color="red">
          Missing Information
        </Badge>
      ),
    }[status] ?? (
      <Badge variant="secondary" color="gray">
        {status}
      </Badge>
    )
  )
}
